module.exports = __webpack_public_path__ + "img/长沙矿冶研究院有限责任公司.63f0c3ac.png";